module.exports = __webpack_public_path__ + "img/six_content_item_01.2bc9fc54.png";